











































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { copy } from '../../dndg/helpers';
import { RegistrationData } from '../../model/api';
import AppBase from '../common/base';

@Component
export default class Register extends AppBase {

    model: RegistrationData = <any>{};
    isSubmitEnabled = false;

    async created() {
        if (this.isRegistered) {
            this.gotoSurvey();
        }
        else {
            this.$store.commit('setTheme', { theme: 'registration' });
            await this.initModel();
        }
    }

    private async initModel() {
        this.model = copy(await this.$store.dispatch('loadRegistrationData'));
        if (!this.model.qualification) {
            this.model.qualification = 'other';
        }
        if (!this.model.gender) {
            this.model.gender = 'M';
        }
    }

    private gotoSurvey() {
        if (this.$route.query.s) {
            // Route to correct survey.
            this.$router.replace({ name: 'survey', params: { lang: this.lang, slug: this.$route.query.s }});
        }
        else {
            // Route to survey chooser.
            this.$router.replace({ name: 'survey-chooser', params: { lang: this.lang }});
        }
    }

    async onValidChange(isValid) {
        let privacy = this.$refs.privacy;
        if (privacy instanceof HTMLInputElement) {
            this.isSubmitEnabled = isValid && privacy.checked;
        }
    }

    async onSubmit() {
        let ok = await this.$store.dispatch('updateRegistrationData', { data: this.model });
        if (ok) {
            await this.$store.dispatch('authenticationCheck');
            this.gotoSurvey();
        }
    }

    get isRegistered() {
        return this.$store.state.loggedUser.isRegistered;
    }

    get privacyPopupLink() {
        return { name: 'privacy-policy', query: { popup: true }};
    }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/signup/register.vue